import React, { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import './HolidayPicker.css';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'moment/locale/ka';
import './HolidayCalendar.css';
import CustomToolbar from "./CustomToolbar";
import { isWeekend, startOfToday } from "date-fns";
import MultiDatePicker from "react-multi-date-picker";

const HolidayPicker = () => {
    const [holidayName, setHolidayName] = useState('');
    const [selectedDates, setSelectedDates] = useState([]);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', type: '' });
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const localizer = momentLocalizer(moment);
    const [holidays, setHolidays] = useState([]);
    const [selectedHolidayIds, setSelectedHolidayIds] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [multipleAdd, setMultipleAdd] = useState(false);

    const apiBase = process.env.REACT_APP_API_BASE_URL;

    const fetchHolidaysForYear = async (year) => {
        const response = await axios.get(`${apiBase}/HolidayCalendar/GetHolidays?Year=${year}`);
        if (response.data?.success) {
            return response.data.data.response || [];
        }
        return [];
    };

    const fetchHolidays = async () => {
        try {
            const raw = await fetchHolidaysForYear(currentYear);
            const seenDates = new Set();
            const formatted = raw
                .filter(h => {
                    const dateStr = new Date(h.date).toDateString();
                    if (seenDates.has(dateStr)) return false;
                    seenDates.add(dateStr);
                    return true;
                })
                .map(h => ({
                    id: h.id,
                    title: h.holidayName,
                    start: new Date(h.date),
                    end: new Date(h.date),
                    allDay: true,
                }));
            setHolidays(formatted);
        } catch {}
    };

    const uniqueHolidays = holidays.filter((h, i, a) =>
        a.findIndex(e => e.start.toDateString() === h.start.toDateString()) === i
    );

    useEffect(() => {
        void fetchHolidays();
    }, [currentYear]);

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setShowConfirmationModal(true);
    };

    useEffect(() => {
        console.log(selectedDates)
    }, [selectedDates]);

    const handleConfirmAdd = async () => {
        try {
            const holidaysPayload = multipleAdd
                ? Array.from({ length: 10 }, (_, i) => {
                    const base = selectedDates[0]
                    const localDate = base
                        .set({ year: base.year + i })
                        .format("YYYY-MM-DD")

                    return {
                        date: localDate,
                        name: holidayName,
                        year: base.year + i
                    }
                })
                : selectedDates.map(d => {
                    return {
                        date: d.format("YYYY-MM-DD"),
                        name: holidayName,
                        year: d.year
                    }
                })

            const response = await axios.post(
                `${apiBase}/HolidayCalendar/CreateHolidayCalendar`,
                { holidays: holidaysPayload }
            )

            setShowConfirmationModal(false)

            if (response.data.success) {
                setHolidayName('')
                setSelectedDates([])
                setAlert({ show: true, message: 'დასვენების დღე დაემატა წარმატებით', type: 'success' })
                await fetchHolidays()
            } else {
                setAlert({ show: true, message: response.data.errors?.[0]?.message || 'შეცდომა', type: 'error' })
            }
        } catch {
            setShowConfirmationModal(false)
            setAlert({ show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!', type: 'error' })
        }
    }


    const areSameMonthAndDay = (dateA, dateB) => {
        const a = new Date(dateA);
        const b = new Date(dateB);
        return a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    };

    const buildDeletionIdsForNextTenYears = async (anchorDate) => {
        const startYear = anchorDate.getFullYear();
        const endYear = startYear + 9;
        const ids = [];
        for (let y = startYear; y <= endYear; y++) {
            const yearHolidays = await fetchHolidaysForYear(y);
            yearHolidays.forEach(h => {
                if (areSameMonthAndDay(h.date, anchorDate)) {
                    ids.push(h.id);
                }
            });
        }
        return ids;
    };

    const handleSelectHoliday = async (event) => {
        try {
            const eventDate = new Date(event.start);
            const idsToDelete = await buildDeletionIdsForNextTenYears(eventDate);
            setSelectedHolidayIds(idsToDelete);
            const dateLabel = moment(eventDate).format('DD/MM');
            setShowPopup(true);
        } catch {
            setAlert({ show: true, message: 'ვერ მოვახერხეთ წაშლისთვის საჭირო მონაცემების მომზადება', type: 'error' });
        }
    };

    const handleDeleteSelectedHolidays = async () => {
        if (selectedHolidayIds.length === 0) {
            setShowPopup(false);
            return;
        }
        try {
            const response = await axios.delete(`${apiBase}/HolidayCalendar/DeleteHolidayCalendar`, {
                data: { holidaysids: selectedHolidayIds }
            });

            if (response.data.success) {
                setSelectedHolidayIds([]);
                await fetchHolidays();
                setAlert({ show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success' });
            } else {
                setAlert({ show: true, message: 'ვერ წაიშალა', type: 'error' });
            }
        } catch {
            setAlert({ show: true, message: 'დაფიქსირდა შეცდომა წაშლის დროს', type: 'error' });
        } finally {
            setShowPopup(false);
        }
    };

    const handleCreateAutomaticallyWeekends = async (includeSaturdays) => {
        try {
            const response = await axios.post(`${apiBase}/HolidayCalendar/CreateAutomaticallyWeekends`, {
                year: currentYear,
                saturday: includeSaturdays
            });

            if (response.data.success) {
                setAlert({ show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success' });
                await fetchHolidays();
            } else {
                setAlert({ show: true, message: 'ვერ დაემატა', type: 'error' });
            }
        } catch {
            setAlert({ show: true, message: 'შეცდომა დამატებისას', type: 'error' });
        }
    };

    const handleRemoveAutomaticallyWeekends = async (includeSaturdays) => {
        try {
            const response = await axios.delete(`${apiBase}/HolidayCalendar/RemoveAutomaticallyWeekends`, {
                data: { year: currentYear, saturday: includeSaturdays }
            });

            if (response.data.success) {
                setAlert({ show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success' });
                await fetchHolidays();
            } else {
                setAlert({ show: true, message: 'ვერ წაიშალა', type: 'error' });
            }
        } catch {
            setAlert({ show: true, message: 'შეცდომა წაშლისას', type: 'error' });
        }
    };

    const onNavigate = (date) => {
        const newYear = date.getFullYear();
        if (newYear !== currentYear) {
            setCurrentYear(newYear);
        }
    };

    const handleCheckBoxChange = () => {
        setMultipleAdd(!multipleAdd);
    };

    const customDayPropGetter = (date) => {
        const isHoliday = holidays.some(h => moment(h.start).isSame(date, 'day'));
        const isPastOrToday = date <= startOfToday();
        return {
            style: {
                backgroundColor: isHoliday || isWeekend(date) ? 'pink' : 'lightgray',
                pointerEvents: isPastOrToday ? 'none' : 'auto',
                opacity: isPastOrToday ? 0.6 : 1,
                cursor: isPastOrToday ? 'default' : 'pointer'
            }
        };
    };

    return (
        <div className={"holiday-picker-main-container"}>
            <h1 className="employee-form-title">დასვენების დღეები</h1>
            <div className={"holiday-picker-actions"}>
                <div className="holiday-picker-container">
                    <form onSubmit={handleFormSubmit}>
                        <div className={"holiday-picker-container-title"}>დასვენების დღის დამატება</div>
                        <div className="holiday-picker-input">
                            <TextField
                                label="სახელი"
                                variant="outlined"
                                value={holidayName}
                                onChange={(e) => setHolidayName(e.target.value)}
                                autoComplete="off"
                            />
                        </div>
                        <div className="holiday-picker-input">
                            <MultiDatePicker
                                multiple
                                value={selectedDates}
                                onChange={setSelectedDates}
                                format="DD/MM/YYYY"
                                placeholder="აირჩიეთ თარიღები"
                                className="custom-calendar"
                            />
                        </div>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="holiday-picker-submit"
                            disabled={!holidayName || selectedDates.length === 0}
                            style={{ width: "100%" }}
                        >
                            დამატება
                        </Button>
                    </form>
                    {showConfirmationModal && selectedDates !== null &&
                        <ConfirmationModal
                            isOpen={showConfirmationModal}
                            onRequestClose={() => setShowConfirmationModal(false)}
                            onConfirm={handleConfirmAdd}
                            hasCheckBox={(selectedDates.length === 1)}
                            accept={multipleAdd}
                            onChange={handleCheckBoxChange}
                        />}
                    {alert.show && (
                        <CustomAlert
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, show: false })}
                        />
                    )}
                </div>

                <div className="holiday-picker-container">
                    <Button variant="contained" onClick={() => handleCreateAutomaticallyWeekends(true)} style={{ width: "100%", marginTop: "10px" }}>
                        შაბათების დამატება
                    </Button>
                    <Button variant="contained" onClick={() => handleCreateAutomaticallyWeekends(false)} style={{ width: "100%", marginTop: "10px" }}>
                        კვირების დამატება
                    </Button>
                    <Button variant="contained" onClick={() => handleRemoveAutomaticallyWeekends(true)} style={{ width: "100%", marginTop: "10px", backgroundColor: "#d32f2f", color: "#fff" }}>
                        შაბათების წაშლა
                    </Button>
                    <Button variant="contained" onClick={() => handleRemoveAutomaticallyWeekends(false)} style={{ width: "100%", marginTop: "10px", backgroundColor: "#d32f2f", color: "#fff" }}>
                        კვირების წაშლა
                    </Button>
                </div>
            </div>

            <div className="holiday-calendar">
                <Calendar
                    localizer={localizer}
                    events={uniqueHolidays}
                    startAccessor="start"
                    endAccessor="end"
                    views={['month']}
                    onNavigate={onNavigate}
                    onSelectEvent={handleSelectHoliday}
                    className="react-calendar"
                    components={{ toolbar: CustomToolbar }}
                    dayPropGetter={customDayPropGetter}
                />
            </div>

            <ConfirmationModal
                isOpen={showPopup}
                onRequestClose={() => setShowPopup(false)}
                onConfirm={handleDeleteSelectedHolidays}
            />
        </div>
    );
};

export default HolidayPicker;
